module.exports = __webpack_public_path__ + "static/media/project-placeholder.3c52be3b.svg";